/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_CreateInputs */

const en_general_create = /** @type {(inputs: General_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const de_general_create = /** @type {(inputs: General_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {General_CreateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_create = /** @type {((inputs?: General_CreateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_CreateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_create(inputs)
	return de_general_create(inputs)
});